export default __webpack_public_path__ + "static/media/savedTrees.31be9f3d.gif";